import { render, staticRenderFns } from "./CompanyOrmUtilities.vue?vue&type=template&id=0402d970&scoped=true"
import script from "./CompanyOrmUtilities.vue?vue&type=script&lang=js"
export * from "./CompanyOrmUtilities.vue?vue&type=script&lang=js"
import style0 from "./CompanyOrmUtilities.vue?vue&type=style&index=0&id=0402d970&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0402d970",
  null
  
)

export default component.exports